/**
 * Pen tips for `canvasDrawing` ink, and how each one turns the chosen weight
 * into rendered stroke. Kept free of React so the eraser's hit test and the
 * node renderer can agree on how wide a stroke actually paints.
 */

export type DrawingTip = "pen" | "highlighter";

export const DRAWING_TIPS: { key: DrawingTip; name: string }[] = [
  { key: "pen", name: "Pen" },
  { key: "highlighter", name: "Highlighter" },
];

const TIP_KEYS = new Set<string>(DRAWING_TIPS.map((tip) => tip.key));

/** Ink authored with the retired marker tip reads as pen at its own weight. */
export function normalizeDrawingTip(value: unknown): DrawingTip {
  return typeof value === "string" && TIP_KEYS.has(value)
    ? (value as DrawingTip)
    : "pen";
}

export interface DrawingInk {
  strokeWidth: number;
  opacity: number;
  linecap: "round" | "butt";
}

/** How a tip turns the chosen weight into ink. */
export function drawingTipInk(
  tip: DrawingTip,
  strokeWidth: number,
): DrawingInk {
  if (tip === "highlighter") {
    return { strokeWidth: strokeWidth * 6, opacity: 0.3, linecap: "butt" };
  }
  return { strokeWidth, opacity: 1, linecap: "round" };
}

/** Which cursor the pane wears — see `canvas-styles.css`. */
export function drawingCursorTool(
  tip: DrawingTip,
  erasing: boolean,
): "draw" | "highlight" | "erase" {
  if (erasing) return "erase";
  return tip === "highlighter" ? "highlight" : "draw";
}
